import React from 'react'

const OnBoardingComponent = ({windowSize, children, section2Img}) => {
  return (
    <div className="w-full h-full flex min-h-dvh">
        {children}
        <div className="onBoardingSection2 flex flex-col flex-[1] justify-center items-center max-lg:hidden">
            <img src={section2Img ? section2Img : require("../../../assets/onboarding-orders.png")} alt="onBoardingSection2" className=" object-contain max-w-[452px] max-h-[288px] rounded-[8px]" />
        </div>
    </div>
  )};

  export default OnBoardingComponent;